import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { CLOSING_PORTAL_ACTION_TYPE } from '../actions';

const initialState = {
  loans: null,
  loanSummary: null,
  wireInstructions: null,
  fees: null,
  feeTypes: null,
  feeRecommendations: null,
  documents: null,
  draftFeeRecommendations: null,
};

const closingPortalReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case CLOSING_PORTAL_ACTION_TYPE.GET_LOANS:
        draft.loans = payload;
        break;

      case CLOSING_PORTAL_ACTION_TYPE.GET_LOAN_SUMMARY:
        draft.loanSummary = payload;
        break;

      case CLOSING_PORTAL_ACTION_TYPE.GET_WIRE_INSTRUCTIONS:
        draft.wireInstructions = payload;
        break;

      case CLOSING_PORTAL_ACTION_TYPE.GET_FEES:
        draft.fees = payload;
        break;

      case CLOSING_PORTAL_ACTION_TYPE.GET_FEE_TYPES:
        draft.feeTypes = payload;
        break;

      case CLOSING_PORTAL_ACTION_TYPE.GET_FEE_RECOMMENDATIONS:
        draft.feeRecommendations = payload;
        break;

      case CLOSING_PORTAL_ACTION_TYPE.GET_DOCUMENTS:
        draft.documents = payload;
        break;

      case CLOSING_PORTAL_ACTION_TYPE.GET_DRAFT_FEE_RECOMMENDATIONS:
        draft.draftFeeRecommendations = payload;
        break;

      case CLOSING_PORTAL_ACTION_TYPE.RESET_LOAN_VIEW:
        draft.loanSummary = null;
        draft.wireInstructions = null;
        draft.fees = null;
        draft.feeTypes = null;
        draft.feeRecommendations = null;
        draft.documents = null;
        draft.draftFeeRecommendations = null;
        break;

      case CLOSING_PORTAL_ACTION_TYPE.RESET:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default closingPortalReducer;
